var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdditionalInfoPptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89984 8.20016H7.5665V10.3335H8.9665C9.3665 10.3335 9.5665 10.2002 9.7665 10.0002C9.9665 9.80016 10.0332 9.60016 10.0332 9.26683C10.0332 8.9335 9.9665 8.7335 9.7665 8.5335C9.5665 8.3335 9.29984 8.20016 8.89984 8.20016ZM9.83317 1.3335H4.49984C4.14622 1.3335 3.80708 1.47397 3.55703 1.72402C3.30698 1.97407 3.1665 2.31321 3.1665 2.66683V13.3335C3.1665 13.6871 3.30698 14.0263 3.55703 14.2763C3.80708 14.5264 4.14622 14.6668 4.49984 14.6668H12.4998C12.8535 14.6668 13.1926 14.5264 13.4426 14.2763C13.6927 14.0263 13.8332 13.6871 13.8332 13.3335V5.3335L9.83317 1.3335ZM10.6332 10.6668C10.2332 11.0002 9.89984 11.1335 9.03317 11.1335H7.5665V13.3335H6.49984V7.3335H9.03317C9.89984 7.3335 10.2998 7.5335 10.6332 7.86683C11.0332 8.26683 11.1665 8.66683 11.1665 9.26683C11.1665 9.86683 11.0332 10.3335 10.6332 10.6668ZM9.1665 6.00016V2.3335L12.8332 6.00016H9.1665Z",
    fill: "#343435"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionalInfoPptIcon);
export default __webpack_public_path__ + "static/media/AdditionalInfoPptIcon.32ae77b38e13f00c8399d2af68b7a573.svg";
export { ForwardRef as ReactComponent };